/* eslint-disable */
import { IconButton, TableCell, TableHead, TableRow } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import {
  SortableTableBody,
  SortableTableRow
} from "@saleor/components/SortableTable";
import { RotaryDetailsFragment_items } from "@saleor/fragments/types/RotaryDetailsFragment";
import useNotifier from "@saleor/hooks/useNotifier";
import { maybe, renderCollection, stopPropagation } from "@saleor/misc";
import { ReorderAction } from "@saleor/types";
import { RotaryTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { RotaryPageFormData } from "../RotaryPage";
export interface RotaryItemsProps {
  disabled: boolean;
  items: RotaryDetailsFragment_items[];
  onItemsAdd: () => void;
  onValueDelete: (id: string) => void;
  onValueReorder: ReorderAction;
  onValueUpdate: (id: string) => void;
  data: RotaryPageFormData;
}
const useStyles = makeStyles(
  theme => ({
    columnDrag: {
      width: 48 + theme.spacing(1.5)
    },
    columnText: {
      width: 300
    },
    dragIcon: {
      cursor: "grab"
    },
    iconCell: {
      "&:last-child": {
        paddingRight: theme.spacing()
      },
      width: 80
    },
    link: {
      cursor: "pointer"
    },
    probability: {
      width: "auto"
    },
    voucher: {
      width: "auto"
    }
  }),
  { name: "RotaryItems" }
);

const RotaryItems: React.FC<RotaryItemsProps> = ({
  disabled,
  onItemsAdd,
  onValueDelete,
  onValueReorder,
  onValueUpdate,
  items,
  data
}) => {
  const classes = useStyles({});
  const intl = useIntl();

  const [probabilityNum, setProbabilityNum] = React.useState<any>();
  function accMul(arg1, arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length;
    } catch (e) {}
    try {
      m += s2.split(".")[1].length;
    } catch (e) {}
    return (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    );
  }
  function accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
  }

  React.useEffect(() => {
    let probability: number = 0;
    items?.length &&
      items?.filter(
        x => (probability = accAdd(probability, Number(x.probability)))
      );
    setProbabilityNum(accMul(probability, 100) || "0");
  }, [items]);
  const notify = useNotifier();
  const handleSubmit = () => {
    if (data.rotaryType === RotaryTypeEnum.TURNTABLE && items.length >= 4) {
      // ScrollSlide();
      notify({
        status: "warning",
        text: "Rotary must set four rotary items."
      });
      return undefined;
    }
    onItemsAdd();
  };

  return (
    <Card id="rotaryItems">
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Rotary Items",
          description: "section header"
        })}
        titleSpan={`(Probability Sum: ${probabilityNum}%)  `}
        titleHint={`${
          data.rotaryType === RotaryTypeEnum.TURNTABLE
            ? "Rotary must set four rotary items."
            : ""
        }`}
        toolbar={
          <Button color="primary" variant="text" onClick={handleSubmit}>
            <FormattedMessage
              defaultMessage="Assign Items"
              description="assign rotary items button"
            />
          </Button>
        }
      />
      <ResponsiveTable>
        <TableHead>
          <TableRow>
            <TableCell className={classes.columnDrag} />
            <TableCell className={classes.columnText}>
              <FormattedMessage defaultMessage="Text" description="Text" />
            </TableCell>
            <TableCell className={classes.probability}>
              <FormattedMessage
                defaultMessage="Probability"
                description="Probability"
              />
            </TableCell>
            <TableCell className={classes.voucher}>
              <FormattedMessage
                defaultMessage="voucher"
                description="voucher"
              />
            </TableCell>
            <TableCell className={classes.iconCell} />
          </TableRow>
        </TableHead>
        <SortableTableBody onSortEnd={onValueReorder}>
          {renderCollection(
            items,
            (item, itemIndex) => (
              <SortableTableRow
                hover={!!item}
                onClick={!!item ? () => onValueUpdate(item.id) : undefined}
                key={maybe(() => item.id)}
                index={itemIndex || 0}
              >
                <TableCell className={classes.columnText}>
                  {maybe(() => item.text) ? (
                    item.text
                  ) : maybe(() => item?.voucher?.code) ? (
                    item?.voucher?.code
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.probability}>
                  {maybe(() => item.probability)
                    ? accMul(Number(item.probability), 100) + "%"
                    : 0}
                </TableCell>
                <TableCell className={classes.voucher}>
                  {maybe(() => item?.voucher?.code) ? (
                    item?.voucher?.code
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.iconCell}>
                  <IconButton
                    disabled={disabled}
                    onClick={stopPropagation(() => onValueDelete(item.id))}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </SortableTableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={3}>
                  <FormattedMessage
                    defaultMessage="No items found"
                    description="No rotary items found"
                  />
                </TableCell>
              </TableRow>
            )
          )}
        </SortableTableBody>
      </ResponsiveTable>
    </Card>
  );
};
RotaryItems.displayName = "RotaryItems";
export default RotaryItems;
